import React from 'react';
// Modules
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// Context
import { useLogsData } from '../../../context/LogsContext';
// Components
import Pager from '../../../components/pager/Pager';
import LogsCard from './LogsCard';
import LogsTable from './LogsTable';
import TableLegend from './TableLegend';

export default function LogList() {
  // Context
  const { state, dispatch } = useLogsData();

  // Methods
  const handlePageChange = (page) => {
    dispatch({
      type: 'SET_PAGER',
      payload: {
        ...state.pager,
        page: page,
      },
    });
  };

  return (
    <>
      {state.listViewMode === 0 && <LogsCard />}
      {state.listViewMode === 1 && <LogsTable />}
      <Row>
        <Col>{state.data.items.length > 0 && <TableLegend />}</Col>
        <Col>
          <Pager
            currentPage={state.pager.page}
            totalPages={Math.ceil(state.data.totalResults / state.pager.recordsPerPage)}
            onPageChange={handlePageChange}
          />
        </Col>
      </Row>
    </>
  );
}
